import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import languages from './languages'

let resources = {}
languages.forEach(el => {
    if (el.is_enabled) {
        resources[el.value] = {}
        resources[el.value].translations = el.translations
    }
})

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en-US',
        supportedLngs: ['en-US', 'ru-RU'],
        preload: true,
        interpolation: {
            escapeValue: false,
        },
        cleanCode: true,
        ns: ['translations'],
        defaultNS: ['translations'],
        resources,
        nsSeparator: false,
        keySeparator: false,
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupQuerystring: 'lng',
            lookupLocalStorage: 'lng',
            caches: ['localStorage'],
        },
        returnEmptyString: false,
    })

export default i18n
